import API from '@/assets/libraries/API_Requests';
import { OfflineModeMiscDataStorage } from '@/services/OfflineMode';
import { useAuthStore } from '@/stores/auth';
import moment from 'moment';

export async function getUserDetails({ skip_cache = false } = {}) {
	try {
		const authStore = useAuthStore();
		if (skip_cache != true && authStore.user_info != undefined && authStore.user_info.last_received_at != undefined && moment(authStore.user_info.last_received_at).isAfter(moment().subtract(15, 'minutes'))) {
			return authStore.user_info;
		}

		const response = await API.Call('GET', `${API.CSC_API_URL}/users/me`);

		if (response.error?.title == 'NO_NETWORK_CONNECTION') {
			//Fallback to local data
			const user_data = await OfflineModeMiscDataStorage.getDataForEntityType(OfflineModeMiscDataStorage.ENTITY_TYPES.USER_DETAILS);
			console.log('Loaded local user data', user_data);

			return user_data;
		}

		OfflineModeMiscDataStorage.updateEntity({ entity_type: OfflineModeMiscDataStorage.ENTITY_TYPES.USER_DETAILS, entity_data: response }).catch((error) => {
			console.log('Error storing user data locally', error);
		});

		if (response.error == undefined) {
			response.last_received_at = moment().toISOString();
			authStore.setUser(response);
		}

		return response;
	} catch (error) {
		return { error };
	}
}

export async function getSubscriptionDetails({ skip_cache = false } = {}) {
	try {
		const authStore = useAuthStore();
		if (skip_cache != true && authStore.subscriptions != undefined && authStore.subscriptions_last_received_at != undefined && moment(authStore.subscriptions_last_received_at).isAfter(moment().subtract(15, 'minutes'))) {
			return authStore.subscriptions;
		}

		const response = await API.Call('GET', `${API.COBRA_PORTAL_API_URL}/payments/subscriptions`);

		if (response.error?.title == 'NO_NETWORK_CONNECTION') {
			//Fallback to local data
			const subscriptions = await OfflineModeMiscDataStorage.getDataForEntityType(OfflineModeMiscDataStorage.ENTITY_TYPES.SUBSCRIPTIONS);
			console.log('Loaded local subscriptions', subscriptions);

			return subscriptions;
		}

		OfflineModeMiscDataStorage.updateEntity({ entity_type: OfflineModeMiscDataStorage.ENTITY_TYPES.SUBSCRIPTIONS, entity_data: response }).catch((error) => {
			console.log('Error storing subscriptions locally', error);
		});

		if (response.error == undefined) {
			authStore.setSubscriptionDetails(response, moment().toISOString());
		}

		return response;
	} catch (error) {
		return {
			error,
		};
	}
}
